import { AsyncPipe } from "@angular/common";
import { ChangeDetectorRef, Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { BehaviorSubject } from "rxjs";
import { FormFields } from "src/app/components/default/form/form.definition";
import { FormOptions } from "src/app/components/default/form/form.interface";
import { DefaultMarkerDisplayComponent } from "src/app/components/global/prefixes/templates/template-map/default-marker-display/default-marker-display.component";
import { MarkerData } from "src/app/components/global/prefixes/templates/template-map/template-map.component";
import { FormComponent } from "../../../../form/form.component";

export type DefaultMarkerDisplayData = {
  fields: FormFields;
};

@Component({
  selector: "app-table-map-view-marker-display",
  imports: [MatProgressSpinnerModule, AsyncPipe, MatIconModule, FormComponent],
  templateUrl: "./table-map-view-marker-display.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./table-map-view-marker-display.component.less",
})
export class TableMapViewMarkerDisplayComponent extends DefaultMarkerDisplayComponent<DefaultMarkerDisplayData> implements OnInit {
  public options: FormOptions;
  public selected: BehaviorSubject<MarkerData<DefaultMarkerDisplayData> | null>;

  private cd = inject(ChangeDetectorRef);

  public fields: FormFields | null;

  public constructor() {
    super();
    this.options = {
      attachments: false,
      foot: false,
      head: false,
      multi: false,
      title: false,
    };
    this.selected = new BehaviorSubject<MarkerData<DefaultMarkerDisplayData> | null>(null);
    this.fields = null;

    this.selected.subscribe((s) => (this.fields = s?.data?.fields ?? null));
  }

  public ngOnInit(): void {
    this.addSubscription(
      this.selectedIndex.subscribe((index) => {
        this.selected.next(this.data?.at(index) ?? null);
        this.cd.markForCheck();
      }),
    );
  }
}
